var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 330,
    viewBox: "0 0 65 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-242.988 327.982C-224.073 304.594 -219.954 300.888 -200.546 286.072C-195.791 282.441 -186.547 276.73 -175.129 271.274C-171.712 269.64 -168.324 268.157 -164.983 266.798C-141.076 257.105 -114.293 255.736 -87.8423 257.988C-20.3532 263.738 40.5588 227.206 58.3161 171.895C76.1018 116.489 46.8417 54.9628 1.18147 24.9409C-4.75977 21.035 -32.7956 3.80491 -63.5553 1.25794C-160.675 -6.81063 -199.483 87.2656 -228.866 230.409C-229.436 233.194 -231.609 246.451 -231.998 249.264L-242.998 327.992L-242.988 327.982Z",
    stroke: "#A8AEBE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector15);
export default __webpack_public_path__ + "static/media/vector1-5.7b21f9f911a07753658b623194d87468.svg";
export { ForwardRef as ReactComponent };